import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../environments/environment';

@Injectable()
export class IpService {

  public url: string;
  constructor(private httpClient: HttpClient) {
    this.url = environment.backend;
  }

  getGeoloc() {
    return new Promise ((resolve, reject) => {
      this.httpClient
        .get<any>(this.url + '/ip/getGeoloc')
        .subscribe(
          (ipinfos) => {
            resolve(ipinfos);
          },
          (error) => {
            reject(error);
          }
        );
    });
  }

}
